import { render, staticRenderFns } from "./comboTipoInscricao.vue?vue&type=template&id=5c83ee4d&scoped=true"
import script from "./comboTipoInscricao.vue?vue&type=script&lang=js"
export * from "./comboTipoInscricao.vue?vue&type=script&lang=js"
import style0 from "./comboTipoInscricao.vue?vue&type=style&index=0&id=5c83ee4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c83ee4d",
  null
  
)

export default component.exports